import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c7228e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "receivable-forecast-summary receivable-list-page" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "search-bar collapsed" }
const _hoisted_4 = { class: "search-bar-body" }
const _hoisted_5 = { class: "search-actions" }
const _hoisted_6 = { class: "list-panel" }
const _hoisted_7 = { class: "list-toolbar" }

import { computed, nextTick, onMounted, onUnmounted, reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import {
  buildForecastSummaryExportQueryData,
  pickClosestLDate,
  queryForecastSummaryLDateOptions,
  queryReceivableForecastSummaryList,
  queryReceivableForecastSummaryToolbarAuth,
  RECEIVABLE_FORECAST_SUMMARY_EXPORT_PATH,
  RECEIVABLE_FORECAST_SUMMARY_MODEL,
  type ReceivableForecastSummaryItem,
  type ReceivableForecastSummaryToolbarAuth,
} from './index';
import { useResizableColumns } from '../tableColumnResize';
import ExportDialog from '../receivableManage/ExportDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'receivableForecastSummary',
  props: {
    onClose: null
  },
  setup(__props: any) {



const searchForm = reactive({
  lDate: undefined as string | undefined,
});

const lDateOptions = ref<{ value: string; label: string }[]>([]);
const lDateFetching = ref(false);
const loading = ref(false);
const dataSource = ref<ReceivableForecastSummaryItem[]>([]);
const exportVisible = ref(false);
const tableAreaRef = ref<HTMLElement | null>(null);
const tableRenderKey = ref(0);

const toolbarAuth = reactive<ReceivableForecastSummaryToolbarAuth>({
  canExport: false,
});

const TABLE_ROW_HEIGHT = 36;
const TABLE_HEADER_HEIGHT = 36;
const TABLE_SCROLLBAR_SIZE = 17;
const TABLE_BODY_FALLBACK = TABLE_ROW_HEIGHT * 8 + TABLE_SCROLLBAR_SIZE;
const tableScrollY = ref<number | undefined>(undefined);
const tableAreaMaxHeight = ref<number | undefined>(undefined);
const tableBodyYScroll = ref(false);

const { columns, scrollX, handleResizeColumn } = useResizableColumns(
  [
    { title: '财务大区', dataIndex: 'salesOfficeRegionName', key: 'salesOfficeRegionName', width: 120, ellipsis: true },
    { title: '分公司', dataIndex: 'saleOfficeName', key: 'saleOfficeName', width: 120, ellipsis: true },
    { title: '应收合计', dataIndex: 'remainingReceivableAmt', key: 'remainingReceivableAmt', width: 120, ellipsis: true },
    { title: '逾期金额', dataIndex: 'overdueAmt', key: 'overdueAmt', width: 110, ellipsis: true },
    { title: '月末到期金额', dataIndex: 'monthEndDueAmt', key: 'monthEndDueAmt', width: 120, ellipsis: true },
    { title: '预计逾期金额', dataIndex: 'expectOverdueAmount', key: 'expectOverdueAmount', width: 120, ellipsis: true },
    { title: '预计回款金额', dataIndex: 'expectRepayAmount', key: 'expectRepayAmount', width: 120, ellipsis: true },
    { title: '实际回款金额', dataIndex: 'actualReceiptAmt', key: 'actualReceiptAmt', width: 120, ellipsis: true },
    { title: '实际与预测差异', dataIndex: 'actualExpectDiff', key: 'actualExpectDiff', width: 130, ellipsis: true },
    { title: '回款达成率', dataIndex: 'repaymentRate', key: 'repaymentRate', width: 110, ellipsis: true },
  ],
  { hasSelection: false },
);

const exportQueryData = computed(() => buildForecastSummaryExportQueryData(searchForm.lDate));

const tableScroll = computed(() => {
  if (tableScrollY.value == null) {
    return { x: scrollX.value };
  }
  return { x: scrollX.value, y: tableScrollY.value };
});

const tableAreaStyle = computed(() => {
  const style: Record<string, string> = {};
  if (tableAreaMaxHeight.value != null) {
    style.maxHeight = `${tableAreaMaxHeight.value}px`;
  }
  if (tableScrollY.value != null) {
    style['--receivable-table-body-h'] = `${tableScrollY.value}px`;
  }
  style['--rc-row-height'] = `${TABLE_ROW_HEIGHT}px`;
  style['--rc-header-height'] = `${TABLE_HEADER_HEIGHT}px`;
  return style;
});

function getRowKey(record: ReceivableForecastSummaryItem, index?: number) {
  return `${record?.id || 'row'}-${index ?? 0}`;
}

function rowClassName(record: ReceivableForecastSummaryItem) {
  return record?.summaryRow ? 'forecast-summary-total-row' : '';
}

function handleExport() {
  if (!searchForm.lDate) {
    message.error('日期不能为空');
    return;
  }
  exportVisible.value = true;
}

function handleSearch() {
  if (!searchForm.lDate) {
    message.error('日期不能为空');
    return;
  }
  fetchList();
}

async function loadToolbarAuth() {
  const auth = await queryReceivableForecastSummaryToolbarAuth();
  toolbarAuth.canExport = auth.canExport;
}

async function loadLDateOptions() {
  lDateFetching.value = true;
  try {
    const dates = await queryForecastSummaryLDateOptions();
    lDateOptions.value = dates.map((d) => ({ value: d, label: d }));
    searchForm.lDate = pickClosestLDate(dates);
  } catch (error) {
    lDateOptions.value = [];
    message.error(error instanceof Error ? error.message : '查询日期选项失败');
  } finally {
    lDateFetching.value = false;
  }
}

async function fetchList() {
  if (!searchForm.lDate) {
    dataSource.value = [];
    return;
  }
  loading.value = true;
  try {
    dataSource.value = await queryReceivableForecastSummaryList(searchForm.lDate);
    nextTick(() => {
      requestAnimationFrame(() => updateTableScrollY());
    });
  } catch (error) {
    dataSource.value = [];
    message.error(error instanceof Error ? error.message : '查询失败');
  } finally {
    loading.value = false;
  }
}

function updateTableScrollY() {
  const area = tableAreaRef.value;
  if (!area) {
    tableScrollY.value = undefined;
    tableAreaMaxHeight.value = undefined;
    return;
  }
  const listPanel = area.parentElement as HTMLElement | null;
  const toolbar = listPanel?.querySelector('.list-toolbar') as HTMLElement | null;
  const headerEl = area.querySelector('.ant-table-header') as HTMLElement | null;
  const headerH = headerEl?.offsetHeight || TABLE_HEADER_HEIGHT;

  const panelH = listPanel?.clientHeight || area.clientHeight;
  const toolbarH = toolbar?.offsetHeight || 0;
  // 无分页条：表格区占满 list-panel 剩余高度
  const maxAreaH = Math.max(0, panelH - toolbarH);
  const available = Math.floor(maxAreaH - headerH);
  const needed = Math.max(1, dataSource.value.length) * TABLE_ROW_HEIGHT + TABLE_SCROLLBAR_SIZE;

  if (available <= 0) {
    tableScrollY.value = TABLE_BODY_FALLBACK;
    tableAreaMaxHeight.value = undefined;
    tableBodyYScroll.value = true;
    return;
  }

  tableScrollY.value = available;
  tableAreaMaxHeight.value = maxAreaH || undefined;
  tableBodyYScroll.value = available < needed;
}

let tableAreaRo: ResizeObserver | null = null;

onMounted(async () => {
  window.addEventListener('resize', updateTableScrollY);
  await loadToolbarAuth();
  await loadLDateOptions();
  if (searchForm.lDate) {
    await fetchList();
  }
  nextTick(() => {
    updateTableScrollY();
    if (tableAreaRef.value && typeof ResizeObserver !== 'undefined') {
      tableAreaRo = new ResizeObserver(() => updateTableScrollY());
      tableAreaRo.observe(tableAreaRef.value);
    }
    requestAnimationFrame(() => updateTableScrollY());
  });
});

onUnmounted(() => {
  window.removeEventListener('resize', updateTableScrollY);
  tableAreaRo?.disconnect();
  tableAreaRo = null;
});

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_form, {
            layout: "horizontal",
            colon: false,
            model: searchForm,
            class: "search-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: [12, 12] }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: "日期",
                        required: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: searchForm.lDate,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.lDate) = $event)),
                            "allow-clear": false,
                            placeholder: "选择日期",
                            options: lDateOptions.value,
                            loading: lDateFetching.value
                          }, null, 8, ["value", "options", "loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: handleSearch
            }, {
              default: _withCtx(() => [
                _createTextVNode("查询")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              (toolbarAuth.canExport)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    onClick: handleExport
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 导出 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          ref_key: "tableAreaRef",
          ref: tableAreaRef,
          class: "table-area",
          style: _normalizeStyle(_unref(tableAreaStyle))
        }, [
          (_openBlock(), _createBlock(_component_a_table, {
            key: tableRenderKey.value,
            class: _normalizeClass(["receivable-table", { 'is-y-scroll': tableBodyYScroll.value }]),
            columns: _unref(columns),
            "data-source": dataSource.value,
            loading: loading.value,
            pagination: false,
            scroll: _unref(tableScroll),
            bordered: true,
            "row-key": getRowKey,
            "row-class-name": rowClassName,
            size: "small",
            onResizeColumn: _unref(handleResizeColumn)
          }, null, 8, ["class", "columns", "data-source", "loading", "scroll", "onResizeColumn"]))
        ], 4)
      ])
    ]),
    _createVNode(ExportDialog, {
      visible: exportVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((exportVisible).value = $event)),
      "query-data": _unref(exportQueryData),
      model: _unref(RECEIVABLE_FORECAST_SUMMARY_MODEL),
      path: _unref(RECEIVABLE_FORECAST_SUMMARY_EXPORT_PATH)
    }, null, 8, ["visible", "query-data", "model", "path"])
  ]))
}
}

})